var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmallCheckmarkIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.7056 23C8.95963 23 8.39451 22.718 7.9085 22.1186L2.07643 14.8327C1.64693 14.3274 1.5 13.8808 1.5 13.3637C1.5 12.2121 2.33638 11.366 3.46663 11.366C4.12217 11.366 4.59688 11.601 5.02637 12.1416L9.66039 18.0526L18.8154 3.05764C19.2788 2.29379 19.7648 2 20.5334 2C21.6636 2 22.5 2.84611 22.5 3.98601C22.5 4.40907 22.3757 4.86738 22.0705 5.34919L11.5479 22.0246C11.1184 22.6827 10.5081 23 9.7056 23Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallCheckmarkIcon);
export default __webpack_public_path__ + "static/media/smallCheckmarkIcon.57bca763efaffad384fcc8dc015c91a5.svg";
export { ForwardRef as ReactComponent };